/**
 * Formata um tempo em horas (número, pode ter casas decimais) como duração
 * curta em PT-BR: minutos abaixo de 1h, horas abaixo de 1 dia, "Nd Nh" acima
 * disso. Usado pela coluna "tempo na etapa" da Fila de Fretes (PO1-2784).
 */
export function formatElapsedHours(horas) {
  if (horas === null || horas === undefined || Number.isNaN(Number(horas))) return "-";
  const total = Number(horas);
  if (total < 1) {
    const min = Math.max(1, Math.round(total * 60));
    return `${min}min`;
  }
  if (total < 24) {
    return `${Math.round(total)}h`;
  }
  const dias = Math.floor(total / 24);
  const restoHoras = Math.round(total - dias * 24);
  return restoHoras > 0 ? `${dias}d ${restoHoras}h` : `${dias}d`;
}

const FAIXA_LABELS = {
  ate1d: "Até 1 dia",
  de1a3d: "1 a 3 dias",
  acima3d: "Acima de 3 dias",
};

export function faixaLabel(faixa) {
  return FAIXA_LABELS[faixa] || "-";
}
